import { InjectionKey } from 'vue';
import { ClubSlug } from '@/fairplayer/domain/club/ClubSlug';
import { Auction } from '@/fairplayer/domain/exclusive/Auction';

export const auctionRepositoryKey: InjectionKey<AuctionRepository> = Symbol();

export interface AuctionRepository {
  listByClub(clubSlug: ClubSlug): Promise<Auction[]>;
}
